export default __webpack_public_path__ + "static/media/Canal12_WEB.7cf8a100.svg";